import { clamp } from '@app/utils/clamp'

export type Point = { lat: number; lon: number }

export function createPoint(lat: number, lon: number): Point {
  return { lat, lon }
}

export function createPointFromArray([lat, lon]: [lat: number, lon: number]): Point {
  return { lat, lon }
}

/** MapLibre throws on a latitude past ±90; NaN fails the check too. */
export function isValidLatitude(lat: number): boolean {
  return Math.abs(lat) <= 90
}

export function clampLatitude(lat: number): number {
  return clamp(lat, -90, 90)
}
